import { Fragment } from 'react';
import { useFormikContext } from 'formik';

import SendToField from 'components/common/form/send-to-field';
import TokenAmount from 'components/wallet/token-amount';
import { FormValues } from 'types';

import {
  StyledDescription,
  StyledHeading,
  StyledMount
} from '../../send-view.style';

const EnterReceiverView = () => {
  const formik = useFormikContext<FormValues>();

  return (
    <Fragment>
      <StyledHeading>{formik.values.token}</StyledHeading>
      <StyledMount>
        <TokenAmount amount={formik.values.amount} />
      </StyledMount>
      <SendToField label="Send to" />
      <StyledDescription>
        The account ID must be an existing NEAR account ending in <b>.near</b>{' '}
        or contain exactly 64 characters
      </StyledDescription>
    </Fragment>
  );
};

export default EnterReceiverView;
